<template>
    <div class="l-time-picker" :data-test-id="dataTestId">
        <l-input-text
            v-model="hours"
            :label="''"
            :hide-help-block="true"
            :validator="validateHours"
            :error-message="''"
            :readonly="readonly"
        />
        <span class="l-default-margin-s r-default-margin-s">:</span>
        <l-input-text
            v-model="minutes"
            :label="''"
            :hide-help-block="true"
            :validator="val => 0 <= val && val <= 59"
            :error-message="''"
            :readonly="readonly"
        />
        <span v-if="useMeridianTime" class="l-default-margin-s r-default-margin-s">
            <button class="btn" :disabled="readonly" @click="toggleMeridian()">
                {{ meridian }}
            </button>
        </span>
    </div>
</template>

<script>
import LInputText from "@/components/LInputText";

export default {
    components: {
        LInputText,
    },
    props: {
        value: {
            type: Date,
            required: true,
        },
        useMeridianTime: {
            type: Boolean,
            default: false,
        },
        dataTestId: {
            type: String,
            default: "l-time-picker-input",
        },
        readonly: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            isFocused: false,
            hours: 8,
            minutes: 0,
            meridian: "AM",
        };
    },
    watch: {
        hours: {
            handler(hh) {
                if (this.useMeridianTime && hh > 12) {
                    this.hours = String(hh % 12).padStart(2, "0");
                    this.meridian = "PM";
                }

                this.onChange();
            },
        },
        minutes: {
            handler() {
                this.onChange();
            },
        },
        meridian: {
            handler() {
                this.onChange();
            },
        },
    },
    created() {
        if (!(this.value instanceof Date && !isNaN(this.value))) return;

        let hh = this.value.getHours();
        let mm = this.value.getMinutes();

        if (this.useMeridianTime) {
            this.meridian = hh > 12 || (hh === 12 && mm >= 0) ? "PM" : "AM";

            if (hh > 12) {
                hh = hh % 12;
            }
            if (hh === 0) {
                hh = 12;
            }
        }

        this.hours = String(hh).padStart(2, "0");
        this.minutes = String(mm).padStart(2, "0");
    },
    methods: {
        validateHours(val) {
            if (this.useMeridianTime) {
                return 0 <= val && val <= 12;
            }
            return 0 <= val && val <= 23;
        },
        toggleMeridian() {
            if (this.readonly) {
                return;
            }
            if (this.meridian === "AM") {
                this.meridian = "PM";
            } else {
                this.meridian = "AM";
            }
        },
        onChange() {
            const hours = this.useMeridianTime
                ? (parseInt(this.hours, 10) % 12) + (this.meridian === "PM" ? 12 : 0)
                : parseInt(this.hours, 10);

            const minutes = parseInt(this.minutes, 10);

            // validate

            if (hours < 0 || hours > 24 || minutes < 0 || minutes > 60) {
                return;
            }

            // Note: With this we return a numeric timestamp not a Date object

            const value = new Date(this.value).setHours(hours, minutes);

            this.$emit("change", value);
        },
    },
};
</script>

<style scoped>
.l-time-picker {
    display: flex;
    justify-content: start;
    align-items: center;
}

.l-time-picker >>> .l-input-text {
    width: 40px;
}

.l-time-picker >>> .btn {
    width: 60px;
    margin: 0;
    padding: 10px 20px;
}
</style>
